export default function sanitizeSecret(context?: Record<string, unknown>) {
  if (context == null) {
    return null;
  }

  const sanitizedContext: Record<string, unknown> = {};
  Object.keys(context).forEach((prop) => {
    const val = context[prop];
    if (typeof val === 'string') {
      sanitizedContext[prop] = val.replace(/secret=.*?(&|$)/, '');
    } else {
      sanitizedContext[prop] = context[prop];
    }
  });
  return sanitizedContext;
}
